import axios from 'axios'
import API_SERVER from './server'

export const getPublicAPI = async (url, params = null) => {
   try {
      let response = await axios.get(API_SERVER + url, { params })
      return response.data
   } catch (err) {
      console.log('Public GET API error: ', url, err.message)
   }
}

export const postPublicAPI = async (url, data = null) => {
   try {
      let response = await axios.post(API_SERVER + url, data)
      return response.data
   } catch (err) {
      console.log('Public POST API error', url, err.message)
   }
}

export const putPublicAPI = async (url, data = null) => {
   try {
      let response = await axios.put(API_SERVER + url, data)
      return response.data
   } catch (err) {
      console.log('Public PUT API error', url, err.message)
   }
}
